import React, { useState } from 'react';

const defaultValue = {
  reguasCobrancas: [],
  reguaCobrancaAtual: {},
  passos: [],
  modal: '',
  modalDetalhesCobranca: '',
  selecao: [],
  tipoSelecao: 'NENHUM',
  loading: false,
  totalElements: 0,
  filtroAvancado: {},
  search: '',
  page: 0,
  size: 15,
  sort: 'nome,DESC',
  clientesOcorrencias: [],
  passoIndex: 0,
  cardAtual: {},
  detalheCobranca: {},
};

export const AcompanharReguaCobrancaContext = React.createContext({});

export const AcompanharReguaCobrancaProvider = (props) => {
  return (
    <AcompanharReguaCobrancaContext.Provider
      value={{
        loading: useState(defaultValue.loading),
        totalElements: useState(defaultValue.totalElements),
        filtroAvancado: useState(defaultValue.filtroAvancado),
        search: useState(defaultValue.search),
        page: useState(defaultValue.page),
        size: useState(defaultValue.size),
        sort: useState(defaultValue.sort),
        reguasCobrancas: useState(defaultValue.reguasCobrancas),
        reguaCobrancaAtual: useState(defaultValue.reguaCobrancaAtual),
        passos: useState(defaultValue.passos),
        modal: useState(defaultValue.modal),
        modalDetalhesCobranca: useState(defaultValue.modalDetalhesCobranca),
        selecao: useState(defaultValue.selecao),
        tipoSelecao: useState(defaultValue.tipoSelecao),
        clientesOcorrencias: useState(defaultValue.clientesOcorrencias),
        passoIndex: useState(defaultValue.passoIndex),
        cardAtual: useState(defaultValue.cardAtual),
        detalheCobranca: useState(defaultValue.detalheCobranca),
      }}
    >
      {props.children}
    </AcompanharReguaCobrancaContext.Provider>
  );
};

export const AcompanharReguaCobrancaConsumer = AcompanharReguaCobrancaContext.Consumer;
